export const DATA = {
	test: [
		{
			question:
				"Начнем с главного: на тебя свалилась <span class='red'>глобальная проблема.</span> <span class='grey'>Твоя первая реакция?</span>",
			answers: [
				{
					title:
						"Сразу ринусь в бой: времени на раздумья нет, спасать ситуацию нужно срочно",
					value: 0,
				},
				{
					title:
						"Сперва подумаю о вариантах решения, посоветуюсь с друзьями, прикину возможные последствия...",
					value: 2,
				},
				{
					title:
						"Оценю ситуацию, выберу максимально подходящий сценарий действий и приступлю к его реализации.",
					value: 1,
				},
			],
			comment:
				"Первая реакция говорит, как правило, о твоей привычной схеме взаимодействия с проблемами: предпочитаешь ли ты решать их сразу или откладывать в надежде, что они «как-то сами собой» разрешатся.",
		},
		{
			question:
				"На работе горит срочный и важный проект, ты понимаешь, что <span class='red'>не успеваешь сдать его в срок.</span> <span class='grey'>С какими словами пойдешь к руководству?</span>",
			answers: [
				{
					title:
						'"Я виноват, готов понести наказание – что делать дальше?"',
					value: 2,
				},
				{
					title:
						'"Виноваты коллеги, которые вовремя не завершили свой этап! Штрафуйте всех."',
					value: 0,
				},
				{
					title:
						'"Мне нужно дополнительное время, так как возникли такие-то проблемы. Готов решить их за 2 дня."',
					value: 1,
				},
			],
			comment:
				"Вне зависимости от того, умеешь ли ты принимать огонь на себя или подсознательно стремишься разделить ответственность с окружающими, лучше озвучивать проблему и сразу предлагать возможные сценарии ее разрешения.",
		},
		{
			question:
				"Представь, что ты торопишься на важную встречу, <span class='red'>заканчивается бензин, на заправке очередь, впереди пробки...</span> <span class='grey'>Как поступишь?</span>",
			answers: [
				{
					title:
						"Поеду на остатках бензина, стараясь успеть вовремя – а с возможностью заправки разберусь уже после встречи.",
					value: 2,
				},
				{
					title:
						"Поеду без визита на заправку, но буду готов пересесть на ОТ, если бензин закончится или пробка окажутся слишком серьезной.",
					value: 1,
				},
				{
					title:
						"Заеду заправиться и заодно выскажу заправщику все, что я думаю о его медленной работе! И о пробках тоже.",
					value: 0,
				},
			],
			comment:
				"Как бы ни складывался день, лучше не срывать свое недовольство ситуацией на посторонних. Впрочем, мы уверены, что ты всегда ведешь себя по-мужски и готов к любым неожиданностям!",
		},
		{
			question:
				"Ты услышал, как приятели за спиной обсуждают <span class='red'>твои недавние действия в юмористическом ключе.</span> <span class='grey'>Твои действия?</span>",
			answers: [
				{
					title:
						"Как говорится, за моей спиной они меня могут даже бить... Честно говоря, мне все равно.",
					value: 2,
				},
				{
					title:
						"Им не буду говорить, что я их слышал, однако для себя выводы сделаю.",
					value: 1,
				},
				{
					title:
						"Возмущусь, вмешаюсь в разговор, заставлю их извиниться.",
					value: 0,
				},
			],
			comment:
				"Твоя реакция поможет оценить, насколько для тебя важно мнение окружающих и склонен ли ты прислушиваться к другим, выбирая сценарии решения проблем.",
		},
		{
			question:
				"Ты сходил на интересное собеседование, получил тестовое задание... <span class='red'>и понял, что практически не представляешь, как его выполнять.</span> <span class='grey'>Как будешь выкручиваться?</span>",
			answers: [
				{
					title:
						"Честно напишу, что возникло недопонимание, я представлял характер работы по-другому и вынужден отказаться.",
					value: 0,
				},
				{
					title:
						"Если это смежная сфера, постараюсь разобраться в деталях и выполнить задание, раз я уже обещал.",
					value: 1,
				},
				{
					title:
						"Найду кого-нибудь, кто выполнит задание за меня, а дальше разберусь по ситуации.",
					value: 2,
				},
			],
			comment:
				"Что для тебя важнее: ценность собственного времени ресурсов, чувство долга или стремление хорошо выглядеть в глазах окружающих? Впрочем, в любом случае главное – не игнорировать проблему, а решить ее тем или иным способом.",
		},
		{
			question:
				"Тебе звонит друг: он попал в аварию, машина не на ходу, <span class='red'>просит приехать через полгорода и помочь.</span> <span class='grey'>Поедешь?</span>",
			answers: [
				{
					title: "Конечно! Дружба – это святое, поеду без вопросов.",
					value: 0,
				},
				{
					title:
						"Поехать, наверное, не смогу – но скину ему контакты службы эвакуации или посоветую автоцентр для ремонта.",
					value: 1,
				},
				{
					title:
						"Странная идея: чем я смогу ему помочь? Машины чинить не умею, а уехать оттуда он может и на такси...",
					value: 2,
				},
			],
			comment:
				"Важно не только то, как ты решаешь собственные проблемы, но и то, как ты реагируешь на сложности окружающих. Оцени, готов ли ты включаться в чужие неприятности и насколько активно?",
		},
		{
			question:
				"Насколько сильно тебя могут обеспокоить гипотетические <span class='red'>регулярные сложности со стулом?</span>",
			answers: [
				{
					title:
						"Разве это сложности? Не буду беспокоиться, если проблема не будет усугубляться.",
					value: 2,
				},
				{
					title:
						"Конечно, обеспокоит. Я сразу поменяю питание и начну искать другие способы решения проблемы.",
					value: 0,
				},
				{
					title:
						"Я почитаю в Интернете, что делать в такой ситуации, и приму решение в зависимости от полученной информации.",
					value: 1,
				},
			],
			comment:
				"Несмотря на то, что нерегулярный стул может показаться несерьезной проблемой – это как раз одна из тех неприятностей, которые не стоит пускать на самотек, чтобы не довести до уже серьезных проблем.",
		},
		{
			question:
				"А если тебе скажут, что запор может быть одним из основных <span class='red'>факторов развития геморроя?</span>",
			answers: [
				{
					title:
						"Ну скажут и скажут – у меня ведь геморроя нет. Наверное...",
					value: 0,
				},
				{
					title:
						"Приму информацию к сведению, но активных мер принимать не буду – скорректирую питание и буду наблюдать.",
					value: 1,
				},
				{
					title:
						"Пожалуй, сразу озабочусь решением проблемы – такие перспективы мне точно не нужны!",
					value: 2,
				},
			],
			comment:
				"Имей в виду, что геморрой – это не то заболевание, которое может пройти самостоятельно. Его можно и нужно лечить, воздействуя системно со всех сторон.",
		},
		{
			question:
				"<span class='red'>Знаешь ли ты,</span> как можно бороться с геморроем?",
			answers: [
				{
					title:
						"Мне кажется, это хроническая проблема, которая полностью не уходит никогда...",
					value: 2,
				},
				{
					title:
						"Да что там знать: операцию делают – и проблема решена!",
					value: 0,
				},
				{
					title:
						"Мне кажется, одним способом не обойтись: нужны комплексные решения этой проблемы.",
					value: 1,
				},
			],
			comment:
				"Борьба с геморроем требует комплексных мер: причем не только по его лечению, но и по улучшению качества своей жизни в этот период. Ниже мы расскажем, как можно это делать!",
		},
	],
	results: [
		{
			maxValue: 5,
			scores: "0-5 баллов",
			status: "Тореадор",
			text:
				"А ты стараешься сразу ухватить быка за рога! Стремительно решаешь проблемы, не боишься сложностей и можешь сразу определить, стоит неприятность твоего внимания или нет. Это неплохой подход – однако имей в виду, что некоторые проблемы, которые ты сходу отмел как неважные, потом могут тебя догнать и больно стукнуть.<br/><br/>Советуем внимательнее прислушиваться к себе и брать небольшую паузу оценкой ситуации и ее возможных последствий. Особенно если дело касается здоровья – такие вопросы отметать не стоит!",
		},
		{
			maxValue: 12,
			scores: "6-12 баллов",
			status: "Весы",
			text:
				"И вовсе не по знаку зодиака, а по умению принимать обдуманные и взвешенные решения. Ты готов просчитывать варианты, оценивать риски и брать на себя ответственность. Молодец, продолжай в том же духе!<br/><br/>Единственное, о чем хотим предупредить: помни, что вопросы здоровья могут требовать немедленного внимания к себе. В этом случае лучше не только оценивать и взвешивать проблему, но и сразу начать принимать меры по ее решению.",
		},
		{
			maxValue: 18,
			scores: "13-18 баллов",
			status: "Мистер Осторожность",
			text:
				"Кажется, ты не любишь сложности и стремишься избегать проблем или перекладывать ответственность за их решение на других людей. Это неплохое качество для спокойной жизни – однако помни, что некоторые вопросы откладывать нельзя.<br/><br/>Если ситуация касается проблем на работе, неприятностей в отношениях или сложностей со здоровьем, лучше все же набраться решимости и незамедлительно приступить к ее решению – чтобы не усугублять ситуацию.",
		},
	],
};



// WEBPACK FOOTER //
// ./app/scripts/data.js